import { createCustomGGXTheme } from '@gogovan/entier-web-core/base/theme';

export const trackNTraceThemeOptions = {
  breakpoints: {
    values: {
      xs: 320,
      sm: 720,
    },
  },
};

const tntTheme = createCustomGGXTheme(trackNTraceThemeOptions);

export { tntTheme };
